import { chatEvaluateWithGPTS, chatUserWithGPTS, fetchAllGpts, fetchChatHistory } from '../../util/api';
import { storableError } from '../../util/errors';
import { getFavouriteChats } from '../RuleBooksSearchPage/RuleBooksSearchPage.duck';


export const REQUEST_SPACE_DETAILS = 'app/AiChatBotPage/REQUEST_SPACE_DETAILS';
export const SUCCESS_SPACE_DETAILS = 'app/AiChatBotPage/SUCCESS_SPACE_DETAILS';
export const ERROR_SPACE_DETAILS = 'app/AiChatBotPage/ERROR_SPACE_DETAILS';

export const SUCCESS_FECTH_GPTS = 'app/AiChatBotPage/SUCCESS_FECTH_GPTS';

export const FETCH_CHAT_HISTORY_REQUEST = 'app/AiChatBotPage/FETCH_CHAT_HISTORY_REQUEST';
export const FETCH_CHAT_HISTORY_SUCCESS = 'app/AiChatBotPage/FETCH_CHAT_HISTORY_SUCCESS';
export const FETCH_CHAT_HISTORY_ERROR = 'app/AiChatBotPage/FETCH_CHAT_HISTORY_ERROR';

export const USER_CHAT_REQUEST = 'app/AiChatBotPage/USER_CHAT_REQUEST';
export const USER_CHAT_SUCCESS = 'app/AiChatBotPage/USER_CHAT_SUCCESS';
export const USER_CHAT_ERROR = 'app/AiChatBotPage/USER_CHAT_ERROR';

const initialState = {
  requestSpaceDetails: false,
  spaceDetailsData: null,
  errorSpaceDetails: null,

  gptsDetails: null,

  fetchChatInProgress: false,
  chatDetails: null,
  fetchChatError: null,

  userChatInProgress: false,
  userChatDetails: null,
  userChatError: null,
};

export default function aiChatBotPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case REQUEST_SPACE_DETAILS:
      return { ...state, requestSpaceDetails: true };
    case SUCCESS_SPACE_DETAILS:
      return { ...state, requestSpaceDetails: false, spaceDetailsData: payload.data };
    case ERROR_SPACE_DETAILS:
      return {
        ...state,
        requestSpaceDetails: false,
        spaceDetailsData: null,
        errorSpaceDetails: payload.error,
      };

    case SUCCESS_FECTH_GPTS:
      return { ...state, gptsDetails: payload };

    case FETCH_CHAT_HISTORY_REQUEST:
      return { ...state, fetchChatInProgress: true };
    case FETCH_CHAT_HISTORY_SUCCESS:
      return { ...state, fetchChatInProgress: false, chatDetails: payload };
    case FETCH_CHAT_HISTORY_ERROR:
      return {
        ...state,
        fetchChatInProgress: false,
        chatDetails: null,
        fetchChatError: payload.error,
      };

    case USER_CHAT_REQUEST:
      return { ...state, userChatInProgress: true, userChatError: null, userChatDetails: { chatData: state?.userChatDetails?.chatData, response: null } };
    case USER_CHAT_SUCCESS:
      return { ...state, userChatInProgress: false, userChatDetails: payload, userChatError: null };
    case USER_CHAT_ERROR:
      return {
        ...state,
        userChatInProgress: false,
        userChatDetails: null,
        userChatError: payload.error,
      };

    default:
      return state;
  }
}

export const requestSpaceDetails = () => ({
  type: REQUEST_SPACE_DETAILS,
});
export const successSpaceDetails = data => ({
  type: SUCCESS_SPACE_DETAILS,
  payload: { data },
});
export const errorSpaceDetails = error => ({
  type: ERROR_SPACE_DETAILS,
  payload: { error },
});

export const successFetchGpts = data => ({
  type: SUCCESS_FECTH_GPTS,
  payload: data,
});

export const fetchChatRequest = () => ({
  type: FETCH_CHAT_HISTORY_REQUEST,
});
export const fetchChatSuccess = data => ({
  type: FETCH_CHAT_HISTORY_SUCCESS,
  payload: data,
});
export const fetchChatError = error => ({
  type: FETCH_CHAT_HISTORY_ERROR,
  payload: { error },
});

export const userChatRequest = () => ({
  type: USER_CHAT_REQUEST,
});
export const userChatSuccess = (data) => ({
  type: USER_CHAT_SUCCESS,
  payload: data,
});
export const userChatError = error => ({
  type: USER_CHAT_ERROR,
  payload: { error },
});

export const getChatHistories = (params) => (dispatch, getState, sdk) => {
  dispatch(fetchChatRequest());
  const { uuid } = getState()?.user?.currentUser?.id || {};
  if (!uuid) return null;
  return fetchChatHistory({ user_id: uuid, ...params }).then((res) => {
    dispatch(fetchChatSuccess(res.chatHistory));
    return res;
  }).catch(error => {
    dispatch(fetchChatError(storableError(error)))
  });
};

// export const userChatWithGpt = (params) => (dispatch, getState, sdk) => {
//     dispatch(userChatRequest());
//     return chatUserWithGPTS({ ...params }).then((res) => {
//         dispatch(userChatSuccess(res));
//         return res.responseText;
//     }).catch(error => {
//         dispatch(userChatError(storableError(error)))
//     });
// };


export const userChatWithGpt = (params) => async (dispatch) => {
  dispatch(userChatRequest());

  try {
    const res = await chatUserWithGPTS(params);
    dispatch(userChatSuccess(res));

    if (!res.meta?.skipEvaluation) {
      await chatEvaluateWithGPTS({
        ...params,
        responseText: res.responseText,
        rulebookContext: res.meta?.rulebookContext,
        version: res.meta?.version || 0,
        id: res.meta?.id || "",
        prompt_text: res.meta?.prompt_text || ""
      });

      // fetch("/api/chat-evaluate", {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify({
      //     ...params,
      //     responseText: res.responseText,
      //     rulebookContext: res.meta.rulebookContext
      //   })
      // });
    }

    return res.responseText;

  } catch (error) {
    const storedError = storableError(error);
    dispatch(userChatError(storedError));
    throw storedError;
  }
};

export const getAllGpts = () => (dispatch, getState, sdk) => {
  return fetchAllGpts({}).then((response) => {
    dispatch(successFetchGpts(response.gpts));
  }).catch(error => {
    console.log(error, "error")

  })
};

export const loadData = (params) => (dispatch, getState, sdk) => {
  return Promise.all([
    dispatch(getAllGpts()),
    dispatch(getChatHistories(params)),
    dispatch(getFavouriteChats()),
  ]);
};
